module.exports = __webpack_public_path__ + "static/media/users-purple.9575c34e.svg";